import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put } from "helpers/api_helper";
import slice from "./slice";
import * as URL from "helpers/url_helper";
import { toast } from "react-toastify";

// import { updateAdminToken } from "helpers/common"

const uploadData = async (file, folder_type) => {
  const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
  const REGION = process.env.REACT_APP_AWS_S3_REGION;

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
    region: REGION,
  });
  const ext = file.name.split(".").pop();
  const s3 = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  try {
    const newFileName = new Date().getTime() + "." + ext;
    const params = {
      Bucket: S3_BUCKET + folder_type,
      Key: newFileName,
      Body: file,
      ACL: "public-read",
    };
    return new Promise((resolve, reject) => {
      s3.putObject(params, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(newFileName);
        }
      });
    });
  } catch (error) {
    console.error("Error in UploadData:", error);
  }
};

export const loginUser = createAsyncThunk(
  "admin/login",
  async ({ data, callBack }, Thunk) => {
    try {
      let response = await post(URL.LOGIN_USER, data);
      console.log("response---->", response.token);
      // updateAdminToken(response.token)
      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("user_token", response.token);
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      console.log(error, "<==sss=error");
      toast.error("Invalid credentials!");
      callBack && callBack(error);

      return Thunk.rejectWithValue(error);
    }
  }
);

export const viewUser = createAsyncThunk(
  "admin/view",
  async (payload, Thunk) => {
    try {
      let response = await get(URL.VIEW_USER);

      return response.data;
    } catch (error) {
      return Thunk.rejectWithValue(error);
    }
  }
);

export const updateAdmin = createAsyncThunk(
  "admin/edit/",
  async ({ data, callBack }, Thunk) => {
    try {
      let response = await put(URL.UPDATE_ADMIN + data?._id, data);
      callBack(null, response);
      return response.data;
    } catch (error) {
      callBack(error.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const resetPass = createAsyncThunk(
  "admin/reset",
  async ({ data, callBack }, Thunk) => {
    try {
      let response = await put(URL.RESET_PASSWORD + data?._id, data);
      callBack(null, response);
      return response.data;
    } catch (error) {
      callBack(error.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const uploadFile = createAsyncThunk(
  "uploadFile",
  async ({ data, callback }, Thunk) => {
    try {
      const fileName = await uploadData(data, "/analysis_file");
      const fileUrl = `https://msh-dev.s3.amazonaws.com/analysis_file/${fileName}`;
      callback && callback(null, fileUrl);
      return fileUrl;
    } catch (error) {
      console.log("error", error);
      callback(error.message);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const { logoutUser } = slice.actions;
